export default {
  REFERENCE_CODE: "Référence",
  STATUS: "Statut",
  ITEMS_COUNT: "Nombre de récepteurs",
  ESTIMATIONS_STATUS_CREATED: "Créée",
  ESTIMATIONS_STATUS_PENDING: "En cours",
  ESTIMATIONS_STATUS_CANCEL: "Annulée",
  ESTIMATIONS_STATUS_PICKUP: "Pickup",
  ESTIMATIONS_STATUS_CANCEL_PICKUP: "Pickup annulé",
  ESTIMATIONS_STATUS_APPROVED: "Approuvée",
  CREATE_NEW_ESTIMATION: "Créer une estimation",
  ESTIMATIONS_LIST: "Listes des estimations",
  APPROVE_THIS_ESTIMATION: "Approuver cette estimation",
  CANCEL_THIS_ESTIMATION: "Annuler cette estimation",
  TOTAL: "Total",
  PICKUP_CREATED: "Pickup créé",
  CANCEL_THIS_PICKUP: "Annuler ce pickup",
  PICKUP_CANCELED: "Pickup annulé",
  ESTIMATION_CREATED: "Estimation créée",
  ESTIMATION_DONE: "Estimation préte",
  APPROVE: "Approuver",
  CREATE_NEW_ESTIMATION: "Créer une estimation",
  CREATE_PICKUP: "Créer un pickup",
  VIEW_SHIPMENT_ESTIMATION: "Détails de l'expédition",
  CREATE_NEW_ESTIMATION: "Créer une estimation",
  ESTIMATION_TO_CREATE: "Estimation des expéditions en cours de création vous serez informé par mail quand l'opération est terminée",
  SHIPMENT_TO_CREATE: "Création des expéditions en cours vous serez informé par mail quand l'opération est terminée",
  PICKUP_TO_CREATE: "Création du Pickup en cours création vous serez informé par mail quand l'opération est terminée",
  PICKUP_TO_CANCEL: "Annulation du pickup en cours vous serez informé par mail quand l'opération est terminée",
  SHIPMENT_TO_CANCEL: "Annulation des expéditions en cours vous serez informé par mail quand l'opération est terminée"
}